import * as React from 'react';
import './NotificationModal.scss';
const Check = require('./checkmark.svg');

interface NotificationModalProps {
  hidden: boolean;
  text: string;
  onClick(): void;
}

export const NotificationModal = ({ hidden, text, onClick }: NotificationModalProps) => {
  return (
    <div hidden={hidden} onClick={onClick} className='user-sent-notification-overlay'>
      <div className='user-sent-notification'>
        <img src={Check} />
        {text}
      </div>
    </div>
  );
};
